













import { Component, Vue, Prop } from "vue-property-decorator";
import VServiceTaskTableRowHeader from "./VServiceTaskTableRowHeader.vue";

@Component({
  components: {
    VServiceTaskTableRowHeader
  }
})
export default class VServiceTaskTable extends Vue {
  @Prop({ required: true }) rows!: number;
}
